module.exports = __webpack_public_path__ + "static/sky-run_grzegorz-sudol-ac6ec9782e9c888a93e080a0aafab4ab.jpg";